export const DRAG_TYPE = 'text/plain';

export const JSON_FILE_TYPE = '.json';
export const GEOJSON_FILE_TYPE = '.geojson';
export const KML_FILE_TYPE = '.kml';
export const WKT_FILE_TYPE = '.wkt';
export const SHAPEFILE_FILE_TYPE = '.shp';
export const ACCEPTED_FILE_TYPES = [
  JSON_FILE_TYPE,
  GEOJSON_FILE_TYPE,
  KML_FILE_TYPE,
  WKT_FILE_TYPE,
  SHAPEFILE_FILE_TYPE,
];

export const MIN_POINT_ZOOM_LEVEL = 12;
